import axios from "axios";

export const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : "";

export const http = axios.create({ baseURL: API, withCredentials: true, timeout: 180000 });

export const errText = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ") || fallback;
  return fallback;
};

const seg = typeof Intl !== "undefined" && Intl.Segmenter ? new Intl.Segmenter() : null;
export const abbr = (s, n = 2) => (seg ? [...seg.segment(s || "")].slice(0, n).map((x) => x.segment).join("") : (s || "").slice(0, n));

export const SIGN_KEYS = ["mesha", "vrishabha", "mithuna", "karka", "simha", "kanya", "tula", "vrishchika", "dhanu", "makara", "kumbha", "meena"];

export const karanaName = (t, k) => {
  const names = t.names.karanas;
  if (k === 0) return names[10];
  if (k >= 57) return names[k - 50];
  return names[(k - 1) % 7];
};

export const tithiName = (t, idx) => (idx === 29 ? t.names.amavasya : t.names.tithis[idx % 15]);
